<template>
  <div class="login-page">
    <div class="login-bg"></div>
    <div class="login-grid"></div>

    <main class="login-layout">
      <section class="brand-showcase">
        <div class="brand-mark">
          <i class="el-icon-cpu"></i>
        </div>
        <p class="eyebrow">AI INTELLIGENCE ACCESS</p>
        <h1>胡工技术分析</h1>
        <p class="brand-subtitle">专注AI前沿资讯 · 洞察技术发展趋势</p>

        <div class="capability-grid">
          <div v-for="item in capabilityMetrics" :key="item.title" class="capability-card">
            <i :class="item.icon"></i>
            <div>
              <strong>{{ item.title }}</strong>
              <span>{{ item.desc }}</span>
            </div>
          </div>
        </div>
      </section>

      <section class="login-panel">
        <div class="panel-heading">
          <span class="panel-chip">ADMIN</span>
          <h2>欢迎登录</h2>
          <p>登录您的账号，探索更多AI技术洞察</p>
        </div>

        <el-form :model="form" :rules="rules" ref="loginForm" class="login-form" @submit.native.prevent="handleLogin">
          <el-form-item prop="username">
            <el-input v-model="form.username" prefix-icon="el-icon-user" placeholder="用户名"></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input v-model="form.password" prefix-icon="el-icon-lock" placeholder="密码" type="password" show-password></el-input>
          </el-form-item>
          <el-form-item>
            <el-button class="login-button" :loading="loading" native-type="submit">登录</el-button>
          </el-form-item>
        </el-form>

        <button class="back-link" type="button" @click="$router.push('/')">
          <i class="el-icon-back"></i>
          <span>返回首页</span>
        </button>
      </section>
    </main>
  </div>
</template>

<script>
import api from '../api'

export default {
  name: 'Login',
  data() {
    return {
      form: { username: '', password: '' },
      rules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      loading: false,
      capabilityMetrics: [
        { title: '前沿资讯', desc: '追踪AI最新动态', icon: 'el-icon-news' },
        { title: '深度分析', desc: '洞察技术趋势', icon: 'el-icon-data-analysis' },
        { title: '智能洞察', desc: 'AI驱动的观点', icon: 'el-icon-connection' },
        { title: '未来趋势', desc: '把握技术未来', icon: 'el-icon-position' }
      ]
    }
  },
  methods: {
    handleLogin() {
      this.$refs.loginForm.validate(async (valid) => {
        if (!valid) return
        this.loading = true
        try {
          const { data } = await api.login(this.form)
          localStorage.setItem('token', data.token)
          localStorage.setItem('username', data.username)
          this.$message.success('登录成功')
          this.$router.push(this.$route.query.redirect || '/admin')
        } catch {
          this.$message.error('用户名或密码错误')
        } finally {
          this.loading = false
        }
      })
    }
  }
}
</script>

<style scoped>
.login-page {
  position: relative;
  min-height: 100vh;
  overflow: hidden;
  color: #f4f8ff;
  background: #030814;
}

.login-bg,
.login-grid {
  position: fixed;
  inset: 0;
}

.login-bg {
  background:
    radial-gradient(circle at 16% 18%, rgba(47, 140, 255, 0.34), transparent 26%),
    radial-gradient(circle at 78% 24%, rgba(79, 220, 255, 0.18), transparent 24%),
    radial-gradient(circle at 64% 76%, rgba(245, 185, 79, 0.1), transparent 20%),
    linear-gradient(135deg, #030814 0%, #07111f 50%, #0b1728 100%);
}

.login-grid {
  background-image:
    linear-gradient(rgba(116, 170, 255, 0.08) 1px, transparent 1px),
    linear-gradient(90deg, rgba(116, 170, 255, 0.08) 1px, transparent 1px);
  background-size: 44px 44px;
  mask-image: radial-gradient(circle at center, black, transparent 76%);
}

.login-layout {
  position: relative;
  z-index: 1;
  min-height: 100vh;
  width: min(1320px, calc(100% - 64px));
  margin: 0 auto;
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(480px, 560px);
  gap: 58px;
  align-items: center;
  padding: 54px 0;
}

.brand-showcase {
  max-width: 650px;
}

.brand-mark {
  width: 92px;
  height: 92px;
  display: grid;
  place-items: center;
  border-radius: 26px;
  color: #4fdcff;
  font-size: 52px;
  background: linear-gradient(145deg, rgba(47, 140, 255, 0.22), rgba(79, 220, 255, 0.08));
  border: 1px solid rgba(116, 170, 255, 0.36);
  box-shadow: 0 0 48px rgba(47, 140, 255, 0.24), inset 0 1px 0 rgba(255, 255, 255, 0.1);
}

.eyebrow {
  margin: 28px 0 12px;
  color: #f5b94f;
  font-size: 13px;
  font-weight: 800;
}

.brand-showcase h1 {
  margin: 0;
  color: #ffffff;
  font-size: 56px;
  line-height: 1.12;
  font-weight: 800;
}

.brand-subtitle {
  margin: 18px 0 0;
  color: #aebbd0;
  font-size: 18px;
}

.capability-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
  margin-top: 44px;
}

.capability-card {
  min-height: 92px;
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 18px;
  border-radius: 18px;
  background: rgba(9, 20, 36, 0.68);
  border: 1px solid rgba(116, 170, 255, 0.2);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.07);
  backdrop-filter: blur(16px);
}

.capability-card i {
  color: #4fdcff;
  font-size: 24px;
}

.capability-card strong,
.capability-card span {
  display: block;
}

.capability-card strong {
  color: #f4f8ff;
  font-size: 16px;
  margin-bottom: 5px;
}

.capability-card span {
  color: #7f8ca3;
  font-size: 13px;
}

.login-panel {
  padding: 42px;
  border-radius: 24px;
  background: rgba(9, 20, 36, 0.78);
  border: 1px solid rgba(116, 170, 255, 0.24);
  box-shadow: 0 30px 100px rgba(0, 0, 0, 0.46), inset 0 1px 0 rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(20px);
}

.panel-heading {
  margin-bottom: 30px;
}

.panel-chip {
  display: inline-flex;
  align-items: center;
  min-height: 28px;
  padding: 0 10px;
  color: #f5b94f;
  border-radius: 999px;
  background: rgba(245, 185, 79, 0.1);
  border: 1px solid rgba(245, 185, 79, 0.24);
  font-size: 12px;
  font-weight: 800;
}

.panel-heading h2 {
  margin: 18px 0 8px;
  color: #ffffff;
  font-size: 34px;
  line-height: 1.2;
}

.panel-heading p {
  margin: 0;
  color: #aebbd0;
  font-size: 15px;
}

.login-form >>> .el-input__inner {
  height: 54px;
  color: #f4f8ff;
  background: rgba(3, 8, 20, 0.54);
  border: 1px solid rgba(116, 170, 255, 0.26);
  border-radius: 15px;
}

.login-form >>> .el-input__inner::placeholder {
  color: #7f8ca3;
}

.login-form >>> .el-input__inner:focus {
  border-color: rgba(79, 220, 255, 0.72);
  box-shadow: 0 0 0 4px rgba(47, 140, 255, 0.12);
}

.login-form >>> .el-input__prefix,
.login-form >>> .el-input__suffix {
  color: #7f8ca3;
}

.login-button {
  width: 100%;
  height: 56px;
  color: #ffffff !important;
  border: 0 !important;
  border-radius: 16px !important;
  background: linear-gradient(135deg, #2f8cff, #4fdcff) !important;
  font-size: 17px;
  font-weight: 800;
  box-shadow: 0 18px 44px rgba(47, 140, 255, 0.28);
}

.back-link {
  width: 100%;
  height: 46px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 14px;
  color: #4fdcff;
  border: 1px solid rgba(116, 170, 255, 0.2);
  border-radius: 14px;
  background: rgba(3, 8, 20, 0.32);
  cursor: pointer;
}

@media screen and (max-width: 980px) {
  .login-layout {
    grid-template-columns: 1fr;
    gap: 32px;
    width: min(720px, calc(100% - 32px));
    padding: 32px 0;
  }

  .brand-showcase h1 {
    font-size: 40px;
  }

  .login-panel {
    padding: 30px;
  }
}

@media screen and (max-width: 560px) {
  .capability-grid {
    grid-template-columns: 1fr;
  }

  .brand-mark {
    width: 68px;
    height: 68px;
    border-radius: 20px;
    font-size: 38px;
  }

  .brand-showcase h1 {
    font-size: 32px;
  }

  .brand-subtitle {
    font-size: 15px;
  }

  .login-panel {
    padding: 24px;
    border-radius: 20px;
  }
}
</style>
